import { Switch as S } from "radix-ui";
import { useId } from "react";

export function Switch({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
}) {
  const id = useId();
  return (
    <span className="flex select-none items-center gap-2 text-muted text-xs">
      <S.Root
        id={id}
        checked={checked}
        onCheckedChange={onChange}
        className="relative h-4 w-7 rounded-full bg-line transition-colors data-[state=checked]:bg-accent"
      >
        <S.Thumb className="block size-3 translate-x-0.5 rounded-full bg-fg transition-transform data-[state=checked]:translate-x-3.5 data-[state=checked]:bg-accent-fg" />
      </S.Root>
      <label htmlFor={id} className="cursor-pointer">
        {label}
      </label>
    </span>
  );
}
